import React from "react";

const Login = React.lazy(() => import("../pages/auth/Login"));
const ForgotPassword = React.lazy(() => import("../pages/auth/ForgotPassword"));
const Dashboard = React.lazy(() => import("../pages/dashboard"));
const Profile = React.lazy(() => import("../pages/profile"));
const LocationManagement = React.lazy(() => import("../pages/locationManagement"));
const ServiceManagement = React.lazy(() => import("../pages/serviceManagement"));
const UserManagement = React.lazy(() => import("../pages/userManagement"));
const OrderManagement = React.lazy(() => import("../pages/orderManagement"));
const Settings = React.lazy(() => import("../pages/settings"));
const Role = React.lazy(() => import("../pages/settings/role"));
const TaxOtherCharges = React.lazy(() => import("../pages/settings/taxOtherCharges"));
const UserHomeCounts = React.lazy(() => import("../pages/settings/userHomeCounts"));
const Financials = React.lazy(() => import("../pages/financial"));
const OrderPayments = React.lazy(() => import("../pages/financial/orderPayments"));
const PartnerPayments = React.lazy(() => import("../pages/financial/partnerPayments"));
const PartnerPayout = React.lazy(() => import("../pages/financial/partnerPayout"));
const PartnerPayoutShow = React.lazy(() => import("../pages/financial/partnerPayout/show"));
const TicketManagement = React.lazy(() => import("../pages/ticketManagement"));
const Error404 = React.lazy(() => import("../pages/Error404"));
const Error500 = React.lazy(() => import("../pages/Error500"));
const PrivacyPolicy = React.lazy(() => import("../pages/PrivacyPolicy"));
const TermsConditions = React.lazy(() => import("../pages/TermsConditions"));
const AboutUs = React.lazy(() => import("../pages/AboutUs"));
const PartnerPrivacyPolicy = React.lazy(() => import("../pages/PartnerPrivacyPolicy"));
const PartnerTermsConditions = React.lazy(() => import("../pages/PartnerTermsConditions"));

export const ROUTES = {
  LOGIN: {
    path: "/auth/login",
    element: <Login />,
    isProtected: false,
  },
  FORGOT_PASSWORD: {
    path: "/auth/forgot-password",
    element: <ForgotPassword />,
    isProtected: false,
  },
  DASHBOARD: {
    path: "/dashboard",
    element: <Dashboard />,
    isProtected: true,
  },
  PROFILE: {
    path: "/profile",
    element: <Profile />,
    isProtected: true,
  },
  LOCATION_MANAGEMENT: {
    path: "/location-management",
    element: <LocationManagement />,
    isProtected: true,
  },
  SERVICE_MANAGEMENT: {
    path: "/service-management",
    element: <ServiceManagement />,
    isProtected: true,
  },
  USER_MANAGEMENT: {
    path: "/user-management",
    element: <UserManagement />,
    isProtected: true,
  },
  ORDER_MANAGEMENT: {
    path: "/order-management",
    element: <OrderManagement />,
    isProtected: true,
  },
  FINANCIALS: {
    path: "/financial",
    element: <Financials />,
    isProtected: true,
  },
  ORDER_PAYMENTS: {
    path: "/financial-order-payments",
    element: <OrderPayments />,
    isProtected: true,
  },
  PARTNER_PAYMENTS: {
    path: "/financial-partner-payments",
    element: <PartnerPayments />,
    isProtected: true,
  },
  PARTNER_PAYOUT: {
    path: "/financial-partner-payout",
    element: <PartnerPayout />,
    isProtected: true,
  },
  PARTNER_PAYOUT_SHOW: {
    path: "/financial-partner-payout-show",
    element: <PartnerPayoutShow />,
    isProtected: true,
  },
  SETTINGS: {
    path: "/settings",
    element: <Settings />,
    isProtected: true,
  },
  ROLE: {
    path: "/settings-role",
    element: <Role />,
    isProtected: true,
  },
  TAX_OTHER_CHARGES: {
    path: "/settings-tax-other-charges",
    element: <TaxOtherCharges />,
    isProtected: true,
  },
  USER_HOME_COUNTS: {
    path: "/settings-user-home-counts",
    element: <UserHomeCounts />,
    isProtected: true,
  },
  TICKET_MANAGEMENT: {
    path: "/ticket-management",
    element: <TicketManagement />,
    isProtected: true,
  },
  ERROR404: {
    path: "/404",
    element: <Error404 />,
    isProtected: false,
  },
  ERROR500: {
    path: "/500",
    element: <Error500 />,
    isProtected: false,
  },
  PRIVACY_POLICY: {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
    isProtected: false,
  },
  TERMS_CONDITIONS: {
    path: "/terms-conditions",
    element: <TermsConditions />,
    isProtected: false,
  },
  ABOUT_US: {
    path: "/about-us",
    element: <AboutUs />,
    isProtected: false,
  },
  PARTNER_PRIVACY_POLICY: {
    path: "/partner/privacy-policy",
    element: <PartnerPrivacyPolicy />,
    isProtected: false,
  },
  PARTNER_TERMS_CONDITIONS: {
    path: "/partner/terms-conditions",
    element: <PartnerTermsConditions />,
    isProtected: false,
  },
}

export const routes = Object.values(ROUTES);